import '../css/hotel_review_details.scss';

const createIFrameViewBoxIfNotExist = function() {
    return new Promise(function(resolve) {
        if (!window.TCMS.IFrameViewBox) {
            import('../../../../assets/frontend/js/tcms_base_iFrameViewBox.class.js').then(function({
                IFrameViewBox
            }) {
                window.TCMS.IFrameViewBox = new IFrameViewBox();
                resolve(window.TCMS.IFrameViewBox);
            });
        } else {
            resolve(window.TCMS.IFrameViewBox);
        }
    });
};

const hotelReviewBoxBaseUrl = window.TCMS.isMobile
    ? 'https://urlaub.check24.de/hib/hotel/ratings?hotelId=*_PLACEHOLDER_*'
    : 'https://urlaub.check24.de/hib_popup/*_PLACEHOLDER_*/rating?hideHotelLink=1&tracking=0';

const hotelReviewBoxTrigger = document.querySelectorAll<HTMLElement>('.ck24-HotelReview-Box-trigger');

if (hotelReviewBoxTrigger) {
    hotelReviewBoxTrigger.forEach(function(elem) {
        elem.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            createIFrameViewBoxIfNotExist().then(function() {
                if (!elem.dataset?.hotelid) return;
                const hotelReviewBoxUrl = hotelReviewBoxBaseUrl.replace('*_PLACEHOLDER_*', elem.dataset.hotelid);

                if (window.TCMS.IFrameViewBox) {
                    window.TCMS.IFrameViewBox.open(hotelReviewBoxUrl, elem);
                }
            });
        });
    });
}

const reviewCharts = document.querySelector('.review-summary-charts');
const reviewChartsSwitch = document.querySelector('.review-summary-switch');

if (reviewChartsSwitch) {
    reviewChartsSwitch.addEventListener('click', function(e) {
        const element = e.currentTarget;

        if (element instanceof HTMLElement) {
            if (!reviewCharts) return;
            reviewCharts.classList.toggle('show-all-items');

            if (reviewCharts.classList.contains('show-all-items')) {
                element.innerText = 'Kategorien einklappen';
            } else {
                element.innerText = 'Alle Kategorien ausklappen';
            }
        }
    });
}

/**
 * Comment box
 * */
const readMore = document.querySelectorAll('.list-item > .review-item .review-readmore-cta');

readMore.forEach(function(node) {
    node.addEventListener('click', function(e) {
        const element = e.currentTarget;

        if (element instanceof HTMLElement) {
            const reviewEl = document.querySelector<HTMLElement>('#review-comment-id-' + element.dataset.commentId);

            if (!reviewEl) return;
            reviewEl.classList.toggle('open-comment');

            if (reviewEl.classList.contains('open-comment')) {
                element.innerText = 'Kommentar schließen';
            } else {
                element.innerText = 'weiterlesen';
            }
            window.scrollToTarget(reviewEl);
        }
    });
});
